export default "__VITE_ASSET__afad9be0__"